import { ConflictType } from '@consigli/types';

import { commonValidators, ValidationRules } from '@/utils/validation';

import { FindingFormData } from './types';

/**
 * Validation config for the findings form
 */
export const validationRules: ValidationRules<FindingFormData> = {
  findingType: {
    required: true,
    validate: (value: unknown): string | undefined => {
      return commonValidators.enumValue(
        value,
        ['DOCUMENT', 'PROJECT'] as const,
        'Please select a finding type',
      );
    },
  },
  selectedDocument: {
    required: false,
    validate: (value: unknown): string | undefined => {
      if (value === null || value === undefined) {
        return 'Please select a document';
      }
      return commonValidators.requiredString(value, 'Please select a document');
    },
  },
  textInDocument: {
    required: false,
    minLength: 1,
    validate: (value: unknown): string | undefined => {
      if (value === null || value === undefined) {
        return 'Text in document cannot be empty';
      }
      return commonValidators.stringWithMinLength(value, 1, 'Text in document cannot be empty');
    },
  },
  pageNumber: {
    required: false,
    minValue: 1,
    validate: (value: unknown): string | undefined => {
      return commonValidators.positiveInteger(value, 'Please enter a valid page number');
    },
  },
  conflictMessage: {
    required: true,
    validate: (value: unknown): string | undefined => {
      return commonValidators.requiredString(value, 'Conflict message cannot be empty');
    },
  },
  conflictMessageEn: {
    required: true,
    validate: (value: unknown): string | undefined => {
      return commonValidators.requiredString(value, 'Conflict message (English) cannot be empty');
    },
  },
  conflictType: {
    required: true,
    validate: (value: unknown): string | undefined => {
      const validConflictTypes = Object.values(ConflictType);
      return commonValidators.enumValue(value, validConflictTypes, 'Please select a conflict type');
    },
  },
} as const;
